'use client';

import Image from 'next/image';
import { LocaleLink } from '@/components/locale-link';


/**
 * Desktop-only header brand mark. The search bar used to live here too, but
 * it's now rendered separately by header.tsx so it can sit in the visual
 * center of the screen.
 */
const HeaderLogo = () => {
  return (
    <LocaleLink
      href="/"
      className="flex items-center gap-2.5 min-h-[44px] group shrink-0"
    >
      <Image
        src="/images/logo.svg"
        width={44}
        height={44}
        className="w-11 h-11 object-contain"
        alt="FirmenData Logo"
        priority
        unoptimized
      />
      <span
        className="inline-flex items-baseline text-[22px] tracking-[-0.025em] leading-none"
        style={{ color: 'var(--fd-ink)' }}
      >
        <span className="font-bold">Firmen</span>
        <span className="font-normal">data</span>
      </span>
    </LocaleLink>
  );
};

export { HeaderLogo };
